export default __webpack_public_path__ + "static/media/027-distribution-1.8e2420a2.png";